import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';

const CustomSelect = ({ label, value, onChange, options, error, helperText }) => {
    return (
        <FormControl
            fullWidth
            error={error}
            sx={{
                mb: 2,
                '& .MuiInputBase-root': {
                    fontSize: { xs: '0.9rem', md: '1rem' },          // Match TextField font size
                    padding: { xs: '0px', md: '0px' },             // Consistent padding with TextField
                },
                '& .MuiInputLabel-root': {
                    fontSize: { xs: '0.85rem', md: '1rem' },         // Label font size
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 2,                                 // Consistent border radius
                },
            }}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                value={value}
                onChange={onChange}
                label={label}
                defaultValue=""
            >
                {options.map((option, index) => (
                    <MenuItem
                        key={index}
                        value={option.value}
                        sx={{
                            fontSize: { xs: '0.9rem', md: '1rem' },      // Menu item font size
                            padding: { xs: '10px', md: '12px' },         // Consistent padding inside dropdown
                        }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>


    );
};

export default CustomSelect;
